import React, { useRef, useImperativeHandle, forwardRef } from "react";
import {
  NavigationAnimating,
  NavigationWrapper,
  NavigationColumn,
  NavigationFloat,
  Headline,
  NavigationImageContainer,
} from "../styles/components/navigation";
import { miamiSvg } from "../images/branding/svgs";
import { useColors } from "../context/colorContext";

const NavigationImageWithHeadline = ({ sectionColors, hidden, heading }) => (
  <NavigationImageContainer $hidden={hidden}>
    {miamiSvg(Object.values(sectionColors))}
    {heading && (
      <Headline $colours={sectionColors} $absolute>
        Not in
      </Headline>
    )}
  </NavigationImageContainer>
);

const NavigationWrapperContent = ({
  sectionColors,
  hidden,
  heading,
  float,
}) => (
  <>
    <NavigationImageWithHeadline
      sectionColors={sectionColors}
      heading={heading}
      hidden={hidden}
    />
    <NavigationImageWithHeadline
      sectionColors={sectionColors}
      heading={heading}
      hidden={hidden}
    />
    {!float && (
      <NavigationImageWithHeadline
        sectionColors={sectionColors}
        heading={heading}
        hidden={hidden}
      />
    )}
  </>
);

const Navigation = forwardRef(({ section }, ref) => {
  const { colors } = useColors();
  const sectionColors = colors[section] || {};

  const leftNavigationRef = useRef(null);
  const rightNavigationRef = useRef(null);

  useImperativeHandle(ref, () => ({
    leftNavigationRef,
    rightNavigationRef,
  }));

  useImperativeHandle(ref, () => ({
    leftNavigationRef: leftNavigationRef.current,
    rightNavigationRef: rightNavigationRef.current,
  }));

  return (
    <NavigationAnimating>
      <NavigationColumn $hidden>
        <NavigationFloat>
          <NavigationWrapperContent
            sectionColors={sectionColors}
            heading
            float
          />
        </NavigationFloat>
      </NavigationColumn>
      <NavigationColumn ref={leftNavigationRef} $absolute $left>
        <NavigationWrapper>
          <NavigationWrapperContent
            sectionColors={sectionColors}
            hidden
            heading
          />
        </NavigationWrapper>
      </NavigationColumn>
      <NavigationColumn ref={rightNavigationRef} $absolute $right>
        <NavigationWrapper>
          <NavigationWrapperContent sectionColors={sectionColors} />
        </NavigationWrapper>
      </NavigationColumn>
    </NavigationAnimating>
  );
});

export default Navigation;
